module.exports = __webpack_public_path__ + "static/media/LooseAll.81069a7b.wav";